import Salad from "./Salad";

export * from "./Angry";
export * from "./Annoyed";
export * from "./BicepsFlexed";
export * from "./HandHelping";
export * from "./HandMetal";
export * from "./HeartCrack";
export * from "./HeartHandShake";
export * from "./Laugh";
export * from "./LeafyGreen";
export * from "./Meh";
export * from "./PartyPopper";
export * from "./Ribbon";
export * from "./Salad";

export const Emoji = {
  Salad,
};
